// src/state/reports/types.ts
var UPDATE_REPORTS = "UPDATE_REPORTS";
var EGroupByItemComboSalesReport = /* @__PURE__ */ ((EGroupByItemComboSalesReport2) => {
  EGroupByItemComboSalesReport2["CATEGORY"] = "category";
  EGroupByItemComboSalesReport2["REPORTING_GROUPS"] = "reporting_groups";
  return EGroupByItemComboSalesReport2;
})(EGroupByItemComboSalesReport || {});
var ESalesOverviewReportTemplate = /* @__PURE__ */ ((ESalesOverviewReportTemplate2) => {
  ESalesOverviewReportTemplate2["DEFAULT"] = "default";
  ESalesOverviewReportTemplate2["LEGACY"] = "legacy";
  return ESalesOverviewReportTemplate2;
})(ESalesOverviewReportTemplate || {});
var EReportPeriod = /* @__PURE__ */ ((EReportPeriod2) => {
  EReportPeriod2["CUSTOM"] = "custom";
  EReportPeriod2["SPECIFIC_DATE"] = "specific_date";
  EReportPeriod2["TODAY"] = "today";
  EReportPeriod2["YESTERDAY"] = "yesterday";
  EReportPeriod2["THIS_WEEK"] = "this_week";
  EReportPeriod2["LAST_WEEK"] = "last_week";
  EReportPeriod2["THIS_MONTH"] = "this_month";
  EReportPeriod2["LAST_MONTH"] = "last_month";
  EReportPeriod2["THIS_QUARTER"] = "this_quarter";
  EReportPeriod2["LAST_QUARTER"] = "last_quarter";
  EReportPeriod2["THIS_YEAR"] = "this_year";
  EReportPeriod2["LAST_YEAR"] = "last_year";
  return EReportPeriod2;
})(EReportPeriod || {});
var EReportFileType = /* @__PURE__ */ ((EReportFileType2) => {
  EReportFileType2["PDF"] = "pdf";
  EReportFileType2["XLS"] = "xls";
  return EReportFileType2;
})(EReportFileType || {});
var EReportRepeatType = /* @__PURE__ */ ((EReportRepeatType2) => {
  EReportRepeatType2["DAILY"] = "daily";
  EReportRepeatType2["WEEKLY"] = "weekly";
  EReportRepeatType2["MONTHLY"] = "monthly";
  EReportRepeatType2["QUARTERLY"] = "quarterly";
  EReportRepeatType2["YEARLY"] = "yearly";
  return EReportRepeatType2;
})(EReportRepeatType || {});
var EReportsType = /* @__PURE__ */ ((EReportsType2) => {
  EReportsType2["MASTER"] = "master";
  EReportsType2["LOCATION"] = "location";
  return EReportsType2;
})(EReportsType || {});
var SET_REPORTS = "SET_REPORTS";
var WS_SET_REPORTS = "WS_SET_REPORTS";
var SET_REPORTS_CHANGE_DATA = "SET_REPORTS_CHANGE_DATA";
var RESET_REPORTS_CHANGE_DATA = "RESET_REPORTS_CHANGE_DATA";
var SET_REPORTS_CHANGE_DATA_VALUES = "SET_REPORTS_CHANGE_DATA_VALUES";
var SET_REPORTS_DIFF_OBJECT = "SET_REPORTS_DIFF_OBJECT";
var SET_REPORTS_ERRORS = "SET_REPORTS_ERRORS";
var SET_SELECTED_REPORTS_TYPE = "SET_SELECTED_REPORTS_TYPE";
var SET_REPORTS_SELECTED_MODE = "SET_REPORTS_SELECTED_MODE";
var SET_REPORT_URL = "SET_REPORT_URL";
var SET_IS_REPORT_PDF_LOADING = "SET_IS_REPORT_PDF_LOADING";
var SET_IS_REPORT_SAVING = "SET_IS_REPORT_SAVING";

export { EGroupByItemComboSalesReport, EReportFileType, EReportPeriod, EReportRepeatType, EReportsType, ESalesOverviewReportTemplate, RESET_REPORTS_CHANGE_DATA, SET_IS_REPORT_PDF_LOADING, SET_IS_REPORT_SAVING, SET_REPORTS, SET_REPORTS_CHANGE_DATA, SET_REPORTS_CHANGE_DATA_VALUES, SET_REPORTS_DIFF_OBJECT, SET_REPORTS_ERRORS, SET_REPORTS_SELECTED_MODE, SET_REPORT_URL, SET_SELECTED_REPORTS_TYPE, UPDATE_REPORTS, WS_SET_REPORTS };
